import { create } from 'zustand';
import apiService from '../services/apiService';

const useTimesheetStore = create((set, get) => ({
  projects: [],
  timesheets: [],
  loading: false,
  error: null,

  fetchProjects: async (employeeId = null) => {
    set({ loading: true, error: null });
    try {
      const projects = employeeId 
        ? await apiService.getEmployeeProjects(employeeId)
        : await apiService.getProjects();
      set({ projects, loading: false });
      return { success: true, data: projects };
    } catch (error) {
      set({ loading: false, error: error.message });
      return { success: false, error: error.message };
    }
  },

  submitTimesheet: async (timesheetData) => {
    set({ loading: true, error: null });
    try {
      const result = await apiService.submitTimesheet(timesheetData);
      
      // Update local timesheets
      const { timesheets } = get();
     set({ 
        timesheets: [ ...(Array.isArray(timesheets) ? timesheets : []), result ],
        loading: false 
      });
      
      return { success: true, data: result };
    } catch (error) {
      set({ loading: false, error: error.message });
      return { success: false, error: error.message };
    }
  },

  fetchTimesheets: async (employeeId, startDate, endDate) => {
    set({ loading: true, error: null });
    try {
      const timesheets = await apiService.getTimesheets(employeeId, startDate, endDate);
      set({ timesheets, loading: false });
      return { success: true, data: timesheets };
    } catch (error) {
      set({ loading: false, error: error.message });
      return { success: false, error: error.message };
    }
  },

  updateTimesheet: async (timesheetId, timesheetData) => {
    set({ loading: true, error: null });
    try {
      const result = await apiService.updateTimesheet(timesheetId, timesheetData);
      
      // Update local timesheets
      const { timesheets } = get();
      const arr = Array.isArray(timesheets) ? timesheets : timesheets?.data || [];

      const updatedTimesheets = arr.map(timesheet =>
        timesheet._id === timesheetId ? { ...timesheet, ...result } : timesheet
      );
      set({ 
        timesheets: updatedTimesheets,
        loading: false 
      });
      
      return { success: true, data: result };
    } catch (error) {
      set({ loading: false, error: error.message });
      return { success: false, error: error.message };
    }
  },

  clearError: () => {
    set({ error: null });
  },
}));

export { useTimesheetStore };
